import { Localized } from "@fluent/react"
import { Alert, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { CompanySetting, restoreDefaultCompanySetting } from "./companySettingsApi";
import { useState } from "react";
import { SaveButton } from "../../../app/components/SaveButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { useAppDispatch } from "../../../app/hooks";

interface RestoreDefaultCompanySettingsDialogProps {
    companySetting?: CompanySetting;
    onSaveSuccess: (companySetting: CompanySetting) => void;
    onCancel: () => void;
}

export const RestoreDefaultCompanySettingsDialog: React.FC<RestoreDefaultCompanySettingsDialogProps> = ({ companySetting, onSaveSuccess, onCancel }) => {
    const dispatch = useAppDispatch();

    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const handleConfirm = async () => {
        try {
            const result = await dispatch(restoreDefaultCompanySetting(companySetting?.id ?? ""))
            if (restoreDefaultCompanySetting.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSaveSuccess({ ...result.payload, isDefault: true });
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="company-settings-restore-default">
                    <span>_Przywróć domyślne</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <Localized id="company-settings-restore-default-question">
                    <span>_Czy na pewno chcesz przywrócić ustawienie domyślne?</span>
                </Localized>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <SaveButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}